import { OnboardingFormFields } from '@Types/index';
import { useFormHook } from '@Hooks/index';
import { otherFormSchema } from '../OtherFormSchema';

export const useOtherFormLogic = () => {
  const formMethods = useFormHook({
    formSchema: otherFormSchema,
    mode: 'onChange',
    formDefaultValues: {
      [OnboardingFormFields.ACCOUNT_OPENING_REASON]: '',
    },
    schemaTitle: 'accountOpeningReason',
  });
  return { formMethods };
};
